import { createAction, props } from '@ngrx/store';
import { CheckinReviewState } from './checkin-review.state';
import { DetailsOpenStatusByTraveler } from '../../interface';

/** StateDetailsActions */
const ACTION_SET = '[CheckinReview] set';
const ACTION_UPDATE = '[CheckinReview] update';
const ACTION_RESET = '[CheckinReview] reset';

/** 以下手動定義アクション */
const ACTION_UPDATE_DETAILS_OPEN_STATUS = '[CheckinReview] update details open status';

/**
 * Clear the current store object and replace it with the new one
 */
export const setCheckinReview = createAction(ACTION_SET, props<CheckinReviewState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateCheckinReview = createAction(ACTION_UPDATE, props<Partial<CheckinReviewState>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetCheckinReview = createAction(ACTION_RESET);

/**
 * 搭乗者ごとのDetailsボタンの開閉状態の更新を行うアクション
 */
export const updateDetailsOpenStatusByTraveler = createAction(
  ACTION_UPDATE_DETAILS_OPEN_STATUS,
  props<DetailsOpenStatusByTraveler>()
);
